<template>
  <v-card>
    <v-expansion-panels multiple>
      <v-expansion-panel v-test="{ panel: '' }">
        <v-expansion-panel-header>
          <div id="info">
            <v-icon>
              info
            </v-icon>
            {{ $t('Общая информация') }}
          </div>
        </v-expansion-panel-header>

        <v-expansion-panel-content eager>
          <v-row class="text-left px-4">
            <text-view
                :display="lotTemplate.lotDescription"
                multiline
                :label="$t('Предмет договора (наименование)')" />
            <text-view
                :display="$t(LOT_TYPE_ENUM[lotTemplate.lotType])"
                multiline
                md="6"
                :label="$t('Тип торговой процедуры')" />
            <text-view
                :display="$t(PREMIUM_TYPE_ENUM[lotTemplate.premiumType])"
                multiline
                md="6"
                :label="$t('Способ расчета цены')" />
            <text-view
                v-if="lotTemplate.premiumType === PREMIUM_TYPES.FIX"
                :display="lotTemplate.currency"
                multiline
                md="6"
                :label="$t('Валюта контракта')" />
            <text-view
                :display="lotTemplate.organizer
                  ? lotTemplate.organizer.organizationName
                  : null"
                multiline
                md="6"
                :label="$t('Организатор')" />
            <text-view
                :display="$t('Углеводороды')"
                multiline
                md="6"
                :label="$t('Торговая секция')" />
            <text-view
                v-if="lotTemplate.startCost"
                multiline
                md="6"
                :label="$t('Стоимость лота, ') + $t(VAT_TEXT)"
                :display="`${lotTemplate.startCost} ${$t('руб.')}`" />
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>

      <v-expansion-panel v-if="showIncoterms" v-test="{ panel: '' }">
        <v-expansion-panel-header>
          <div id="incoterms">
            <v-icon>
              mdi-routes
            </v-icon>
            {{ $t('Условия и базис поставки Incoterms') }}
          </div>
        </v-expansion-panel-header>
        <v-expansion-panel-content eager>
          <v-row>
            <text-view
                icon="person"
                :display="lotTemplate.incotermName"
                multiline
                md="6"
                :label="$t('Условия поставки')" />
            <v-col
                cols="12"
                :md="$vuetify.breakpoint.lgAndDown ? 12 : 6">
              <lot-template-delivery-basises
                  v-if="lotTemplate.lotDeliveryBasisTemplates && lotTemplate.lotDeliveryBasisTemplates.length > 0"
                  :value="lotTemplate.lotDeliveryBasisTemplates"
                  :incoterm-id="lotTemplate.incotermId"
                  readonly />
            </v-col>
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>

      <v-expansion-panel v-test="{ panel: '' }">
        <v-expansion-panel-header>
          <div id="contact_mail">
            <v-icon>
              contact_mail
            </v-icon>
            {{ $t('Контактная информация') }}
          </div>
        </v-expansion-panel-header>
        <v-expansion-panel-content eager>
          <v-row class="text-left px-4">
            <text-view
                icon="person"
                :display="lotTemplate.contactPerson"
                multiline
                md="6"
                :label="$t('Контактное лицо')" />
            <text-view
                icon="alternate_email"
                :display="lotTemplate.contactEmail"
                multiline
                md="6"
                :label="$t('Электронный адрес')" />
            <text-view
                icon="settings_phone"
                :display="lotTemplate.contactPhone"
                multiline
                md="6"
                :label="$t('Контактный телефон')" />

          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>

      <v-expansion-panel v-if="positions">
        <v-expansion-panel-header>
          <div id="storage">
            <v-icon>
              storage
            </v-icon>
            {{ $t('Состав торговой процедуры') }}
          </div>
        </v-expansion-panel-header>
        <v-expansion-panel-content eager class="py-2">
          <v-card>
            <slot name="positions" />
          </v-card>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </v-card>
</template>

<script>

  import TextView from '@/components/reused/ui/TextView.vue'
  import LotTemplateDeliveryBasises from './LotTemplateDeliveryBasises.vue'
  import { DICTIONARY_TYPES, LOT_STATUSES, VAT_TEXT, PREMIUM_TYPES } from '@/constants/business'
  import {
    LOT_TYPE_ENUM,
    LOT_STATUS_TYPE_ENUM,
    TRADE_RESULT_TYPE_ENUM,
    PREMIUM_TYPE_ENUM
  } from '@/constants/enums'

  export default {
    components: {
      TextView,
      LotTemplateDeliveryBasises
    },
    props: {
      lotTemplate: {
        type: Object,
        required: true
      },
      positions: {
        type: Boolean,
        default: false
      },
      showIncoterms: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        LOT_TYPE_ENUM,
        DICTIONARY_TYPES,
        LOT_STATUS_TYPE_ENUM,
        TRADE_RESULT_TYPE_ENUM,
        LOT_STATUSES,
        VAT_TEXT,
        PREMIUM_TYPE_ENUM,
        PREMIUM_TYPES
      }
    },
    computed: {
    }
  }
</script>
